import { render } from "./Footer.vue?vue&type=template&id=40ab164b&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=40ab164b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ab164b"],['__file',"src/components/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40ab164b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40ab164b', __exports__)) {
    api.reload('40ab164b', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=40ab164b&scoped=true", () => {
    api.rerender('40ab164b', render)
  })

}


export default __exports__